/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
import React from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";

function VansStatusGrid({ data }: any) {
  return (
    <Grid data={data}>
      <Column
        field="status"
        title="Description"
        className="grid-cell-font-size"
      />

      <Column
        field="count"
        title="Total"
        width="200px"
        className="grid-cell-font-size text-center"
      />
    </Grid>
  );
}

export default VansStatusGrid;
